$.widget("custom.videobutton", {
    options: {
        videoid: "",
        title: "",
    },
    _create: function () {
        var $widget = this,
            $this = $widget.element;
        $this.click(function (e) {
            e.preventDefault();
            $('#modalVideo').find('.modal-title').text($widget.options.title);
            $('#modalVideo').find('iframe').attr("src", "https://www.youtube-nocookie.com/embed/" + $widget.options.videoid + "?rel=0&amp;showinfo=0");
            $('#modalVideo').modal('show');
        });

    }
});
